import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output, signal} from '@angular/core';
import {FormArray, FormControl, FormGroup, Validators} from "@angular/forms";
import {forkJoin} from "rxjs";
import {HttpStatusCode} from "@angular/common/http";
import {ActivatedRoute} from "@angular/router";
import {SalesWorkflowService} from "projects/store/src/app/services/api/v1/sales-workflow.service";
import {RequestService} from "projects/store/src/app/services/api/v1/request.service";
import {CustomMessageService} from "library";
import {UtilService} from "library";
import {ResponseHttpError, ResponseHttpSuccess} from "library";
import {environment} from "projects/store/src/environments/environment";
import {AdditionalFieldTypes} from "projects/store/src/app/enums/additional-field-types";
import {PixelService} from "projects/store/src/app/services/api/v1/pixel.service";


@Component({
  selector: 'app-sales-aditional-information-kedicash',
  templateUrl: './sales-aditional-information-kredicash.component.html',
  styles: [
  ]
})
export class SalesAditionalInformationKredicashComponent implements OnInit{
  form: FormGroup;
  requestId: string;
  groupedFields!: any[];
  groupNumber: number = 0;
  groupsTotal: number = 0;
  additionalDataValues: any;
  visibleErrorModal!: boolean;
  additionalFieldTypes = AdditionalFieldTypes;
  categoryCode: string;
  country = environment.global.country;
  contacts: any[] = [];
  loading = false;
  @Output() nextStepEvent = new EventEmitter();
  isSubmitted = signal<boolean>(false);
  formDisabled = true;
  dropdownLevel1Filter: any;
  dropdownLevel2Filter: any;

  constructor(private salesWorkflowService: SalesWorkflowService,
              private requestService: RequestService,
              private utilService: UtilService,
              private route: ActivatedRoute,
              private customMessageService: CustomMessageService,
              private metaPixelService: PixelService,) {
    this.form = new FormGroup({});
    this.requestId = this.route.snapshot.params['request_id'];
    this.categoryCode = this.route.snapshot.params['category_code'];
    this.requestService.step.set(4);
  }

  ngOnInit() {
    this.load();
    this.form.statusChanges.subscribe(() => {
      setTimeout(() => {
        this.formDisabled = this.form.invalid || this.form.pending;
      });
    });
  }


  load() {
    this.utilService.enablePageLoading();
    forkJoin({
      additionalDataFields: this.salesWorkflowService.getAdditionalDataFields(this.salesWorkflowService.currentStep.category_step_id),
      additionalDataValues: this.requestService.getAdditionalData(this.requestId)
    }).subscribe({
      next: (resp: any)=> {
        if(resp.additionalDataFields.status === HttpStatusCode.Ok) {
          this.groupedFields = resp.additionalDataFields.body.data.list;
          this.groupedFields.forEach((group: any) => {
            group.fields.forEach((field: any) => {
              if(Array.isArray(field.options)) {
                field.options.sort((a: any, b: any) => (a?.name ?? '').localeCompare(b?.name ?? '', 'es', {sensitivity: 'base'}));
              }
            });
          });
          this.groupsTotal = Object.keys(this.groupedFields).length;
        }else{
          this.customMessageService.responseNoticeHandler(resp);
        }

        if(resp.additionalDataValues.status === HttpStatusCode.Ok) {
          this.groupedFields = this.groupedFields.map((group: any) => {
            group.fields.map((field: any) => {
              let data = resp.additionalDataValues.body.data.list.filter((row: any) => row.id == field.id);
              if(data.length === 1) {
                if([this.additionalFieldTypes['dropdown-level1'], this.additionalFieldTypes['dropdown-level2'], this.additionalFieldTypes['dropdown-level3']].includes(data[0].type)) {
                  field.value = JSON.parse(data[0].value);
                }else{
                  field.value = data[0].value;
                }
                if(field.type == this.additionalFieldTypes['dropdown-level1']) {
                  this.dropdownLevel1Filter = field.value
                  this.dropdownLevel2Filter = {id: 0, name: ''}
                }
                if(field.type == this.additionalFieldTypes['dropdown-level2']) {
                  this.dropdownLevel2Filter = field.value
                }
              }
              return field;
            });
            return group;
          });

        }else{
          this.customMessageService.responseNoticeHandler(resp);
        }
        this.utilService.disablePageLoading();
      },
      error: (error: ResponseHttpError) => {
        this.customMessageService.responseNoticeHandler(error);
        this.utilService.disablePageLoading();
      }
    });
  }


  saveDropDown($event: any, field: any) {
    if(field.type == this.additionalFieldTypes['dropdown-level1']) {
      this.dropdownLevel1Filter = $event.value
      this.dropdownLevel2Filter = {id: 0, name: ''}
    }
    if(field.type == this.additionalFieldTypes['dropdown-level2']) {
      this.dropdownLevel2Filter = $event.value
    }
    this.save({...$event, value: JSON.stringify($event.value)});
  }

  save(data: {id: string, value: any, next?: boolean}) {
    this.requestService.saveAdditionalData(this.requestId, data).subscribe({
      next: (resp: ResponseHttpSuccess)=> {

      },
      error: (error: ResponseHttpError) => {
        this.customMessageService.responseNoticeHandler(error);
      }
    });
  }

  onNextStep() {
    this.loading = true;
    this.metaPixelService.trackEvent('SubmitApplication');
    this.nextStepEvent.emit();
  }

  get f(){
    return this.form.controls;
  }


}
